<template>
  <vs-row vs-type="flex" vs-xs="12" vs-md="6" vs-lg="6" id="moodfelekSettingsPage">
    <vs-row vs-type="flex"  vs-xs="12" vs-md="6" vs-lg="6" vs-justify="space-between">
      <vs-col vs-type="flex"  vs-xs="12" vs-md="4" vs-lg="4">
        <vs-row vs-type="flex" vs-xs="12" vs-md="4" vs-lg="4">
          <vs-row vs-type="flex"  vs-xs="12" vs-md="4" vs-lg="4">
            <template>
              <vs-row vs-type="flex" class="m-4" vs-xs="12" vs-md="6" vs-lg="6">
                <vs-row vs-type="flex"  vs-xs="8" vs-md="6" vs-lg="6">
                  <div class="img-container w-full mx-auto flex items-center justify-center">
                    <img v-if="!needUpload" :src="$baseUrl + '/' + moodfelek.image" alt="img" class="responsive">
                    <img v-if="needUpload" :src="moodfelek.image" alt="img" class="responsive">
                  </div>
                </vs-row>
                <input type="file" class="hidden" ref="updateImgInput" @change="updateCurrImg" accept="image/*">
                <vs-row vs-type="flex"  vs-xs="12" vs-md="6" vs-lg="6" class="mt-2">
                  <vs-button class="w-full" type="gradient" @click="$refs.updateImgInput.click()" size="small">Fotoğrafı Güncelle
                  </vs-button>
                </vs-row>
                <vs-row vs-type="flex"  vs-xs="12" vs-md="6" vs-lg="6" class="mt-2">
                  <vs-button class="w-full" type="gradient" color="danger" @click="moodfelek.image = null;" size="small">
                    Fotoğrafı Sil
                  </vs-button>
                </vs-row>
              </vs-row>
              <!-- Image Container -->
            </template>
          </vs-row>
          <vs-divider></vs-divider>
          <vs-row vs-type="flex"   class="m-1 mb-4" vs-xs="12" vs-md="6" vs-lg="6">
            <template>
              <vs-row vs-type="flex" class="m-4"  vs-xs="12" vs-md="6" vs-lg="6">
                <vs-row vs-type="flex"  vs-xs="12" vs-md="6" vs-lg="6" vs-justify="center" class="mb-2">
                  <span class="text-primary text-medium-small weight-600">
                    İngilizce
                  </span>
                </vs-row>
                <vs-row vs-type="flex"  vs-xs="12" vs-md="6" vs-lg="6">
                  <div class="img-container w-full mx-auto flex items-center justify-center">
                    <img v-if="!needUploadEng" :src="$baseUrl + '/' + moodfelek.imageEng" alt="img" class="responsive">
                    <img v-if="needUploadEng" :src="moodfelek.imageEng" alt="img" class="responsive">
                  </div>
                </vs-row>
                <input type="file" class="hidden" ref="updateImgInputEng" @change="updateCurrImgEng" accept="image/*">
                <vs-row vs-type="flex"  vs-xs="12" vs-md="6" vs-lg="6" class="mt-2">
                  <vs-button class="w-full" type="gradient" @click="$refs.updateImgInputEng.click()" size="small">Fotoğrafı Güncelle
                  </vs-button>
                </vs-row>
                <vs-row vs-type="flex"  vs-xs="12" vs-md="6" vs-lg="6" class="mt-2">
                  <vs-button class="w-full" type="gradient" color="danger" @click="moodfelek.imageEng = null;" size="small">
                    Fotoğrafı Sil
                  </vs-button>
                </vs-row>
              </vs-row>
              <!-- Image Container -->
            </template>
          </vs-row>
        </vs-row>
        <div class="upload-img" v-if="!moodfelek.image">
          <input type="file" class="hidden" ref="uploadImgInput" @change="updateCurrImg" accept="image/*">
          <vs-button class="w-full" icon-pack="feather" icon="icon-arrow-up" @click="$refs.uploadImgInput.click()">
            Fotoğraf Yükle</vs-button>
        </div>
      </vs-col>
      <vs-col vs-type="flex" vs-xs="12" vs-md="8" vs-lg="8"  id="moodfelekCampaignOptions">
        <vs-row vs-type="flex"  vs-xs="12" vs-md="6" vs-lg="6">
          <vs-row vs-type="flex"  vs-xs="12" vs-md="6" vs-lg="6" vs-justify="space-between">
            <vs-col vs-type="flex"  vs-xs="12" vs-md="5" vs-lg="5">
              <vs-row vs-type="flex"  class="mb-5" >
                <vs-list>
                  <vs-list-header title="Tüm Kampanyalar" color="primary" class="sale-box-shadow p-2">
                  </vs-list-header>
                  <draggable :list="campaigns" group="moodfelekItem" class="p-2 cursor-move">
                    <div  v-if="campaigns.length>0" >
                    <div class="w-full d-flex my-1" :class="{'selectedCampaign' : campaign.selected}"
                      @click="campaign.selected = !campaign.selected" v-for="campaign in campaigns" :key="campaign.id">
                      <vs-list-item class="campaignList text-smaller" :title="campaign.name">
                        <template slot="avatar">
                          <vs-avatar class="sale-box-shadow"
                            :src="campaign.image ? $baseUrl + '/' + campaign.image : require('@/assets/images/products/product-kahve.png')" />
                        </template>
                      </vs-list-item>
                    </div>
                  </div>
                    <div class="mt-3" v-else ><span >Kampanya Bulunamadı</span></div>
                  </draggable>
                </vs-list>
              </vs-row>
            </vs-col>
            <vs-col vs-type="flex" vs-xs="12" vs-md="2" vs-lg="2" class="px-2 mb-6" vs-justify="center" vs-align="start">
              <vs-row vs-type="flex"  vs-xs="12" vs-md="6" vs-lg="6">
                <vx-tooltip text="Hepsini Sola Al" color="primary" position="top" class="w-full">
                  <vs-button @click="moveToLeft(false,'campaign')" class="w-full" icon-pack="feather"
                    icon="icon-chevrons-left" color="danger" />
                </vx-tooltip>
                <vx-tooltip text="Sola Al" color="primary" position="left" class="w-full">
                  <vs-button @click="moveToLeft(true,'campaign')" class="w-full mt-2" icon-pack="feather"
                    icon="icon-arrow-left" color="secondary" />
                </vx-tooltip>
                <vx-tooltip text="Sağa Al" color="primary" position="right" class="w-full">
                  <vs-button @click="moveToRight(true,'campaign')" class="w-full mt-2" icon-pack="feather"
                    icon="icon-arrow-right" color="secondary" />
                </vx-tooltip>
              </vs-row>
            </vs-col>
            <vs-col vs-type="flex"  vs-xs="12" vs-md="5" vs-lg="5">
              <vs-row vs-type="flex" class="mb-10"    vs-xs="12" vs-md="6" vs-lg="6">
                <vs-list>
                  <vs-list-header title="Seçilen Kampanyalar" class="sale-box-shadow p-2" color="success">
                  </vs-list-header>
                  <draggable :list="moodfelek.campaigns" group="moodfelekItem" class="p-2 cursor-move">
                    <div  v-if="moodfelek.campaigns.length>0" >
                    <div class="w-full d-flex my-1" :class="{'selectedCampaign' : moodfelekItem.selected}"
                      @click="moodfelekItem.selected = !moodfelekItem.selected"
                      v-for="moodfelekItem in moodfelek.campaigns" :key="moodfelekItem.id">
                      <vs-list-item class="campaignList text-smaller" :title="moodfelekItem.name">
                        <template slot="avatar">
                          <vs-avatar class="sale-box-shadow"
                            :src="moodfelekItem.image ? $baseUrl + '/' + moodfelekItem.image : require('@/assets/images/products/product-kahve.png')" />
                        </template>
                      </vs-list-item>
                    </div>
                    </div>
                    <div class="mt-3"  v-else ><span >Seçili Kampanya Bulunamadı</span></div>
                  </draggable>
                </vs-list>
              </vs-row>
            </vs-col>
          </vs-row>
        </vs-row>
      </vs-col>
    </vs-row>
    <vs-row vs-type="flex"  vs-xs="12" vs-md="6" vs-lg="6" vs-justify="center">
      <vs-button type="gradient" color="success" class="saveButton" @click="updateMoodfelekSettings">Kaydet</vs-button>
    </vs-row>
  </vs-row>
</template>

<script>
  import {
    uploadImage
  } from "@/api/User.js";
  import {
    GetNameList
  } from "@/api/Campaign.js";
  import {
    GetMoodfelekSettings,
    UpdateMoodfelekSettings
  } from "@/api/MoodfelekSettings.js";
  import draggable from 'vuedraggable'
  export default {
    data() {
      return {
        moodfelek: {
          image: "",
          campaigns: []
        },
        needUpload: false,
        needUploadEng: false,
        moodfelekPhotoBinary: "",
        moodfelekPhotoBinaryEng: "",
        campaigns: []
      }
    },
    components: {
      draggable
    },
    methods: {
      getCampaignNameList() {
        GetNameList().then(res => {
          if (res && res.status == 200) {
            res.data.forEach(x => x.selected = false);
            this.campaigns = res.data;
            this.syncList();
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Kampanyalar Yüklenemedi !"
            });
          }
        }).catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !"
          });
        
        });
      },
      getMoodfelekSettings() {
        GetMoodfelekSettings().then(res => {
          if (res && res.status == 200) {
            res.data.campaigns.forEach(x => x.selected = false);
            this.moodfelek = res.data;
            this.syncList();
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Moodfelek Ayarları Yüklenemedi !"
            });
          }
        }).catch(() => {
       
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !"
          });
        });
      },
      syncList() {
        if (this.moodfelek.campaigns.length == 0 || this.campaigns.length == 0) return;
        this.moodfelek.campaigns.forEach(x => {
          let defaultBranch = this.campaigns.findIndex(y => y.id == x.id);
          if (defaultBranch >= 0) {
            this.campaigns.splice(defaultBranch, 1);
          }
        });
      },
      uploadImage: async function () {
        if (this.moodfelekPhotoBinary == null || this.moodfelekPhotoBinary == "") return;
        let image = this.moodfelekPhotoBinary;
        let formData = new FormData();
        formData.append('image', image)
        await uploadImage(formData).then(res => {
          if (res.status == 200) {
            this.moodfelek.image = "StaticFiles/images/" + res.data;
            this.needUpload = false;
          } else {
            this.$vs.notify({
              color: 'danger',
              title: 'Hata : ' + res.status,
              text: 'Moodfelek Fotoğrafı Yüklenemedi !'
            });
          }
        }).catch(() => {
          this.$vs.notify({
            color: 'danger',
            title: 'Hata !',
            text: 'Sunucu Bağlantı Hatası !'
          });
        });
      },
      uploadImageEng: async function () {
        if (this.moodfelekPhotoBinaryEng == null || this.moodfelekPhotoBinaryEng == "") return;
        let image = this.moodfelekPhotoBinaryEng;
        let formData = new FormData();
        formData.append('image', image)
        await uploadImage(formData).then(res => {
          if (res.status == 200) {
            this.moodfelek.imageEng = "StaticFiles/images/" + res.data;
            this.needUploadEng = false;
          } else {
            this.$vs.notify({
              color: 'danger',
              title: 'Hata : ' + res.status,
              text: 'Moodfelek İngilizce Fotoğrafı Yüklenemedi !'
            });
          }
        }).catch(() => {
          this.$vs.notify({
            color: 'danger',
            title: 'Hata !',
            text: 'Sunucu Bağlantı Hatası !'
          });
        });
      },
      updateMoodfelekSettings: async function () {
        if (this.moodfelek.campaigns.length == 0) {
          this.$vs.notify({
            color: "warning",
            title: "Moodfelek Ayarları",
            text: "Lütfen Ayarlarınızı Kontrol Ediniz !"
          });
          return;
        }
        (this.needUpload) ? await this.uploadImage(): null;
        (this.needUploadEng) ? await this.uploadImageEng(): null;
        UpdateMoodfelekSettings(this.moodfelek).then(res => {
          if (res && res.status == 200) {
            this.moodfelek.campaigns = res.data.campaigns;
            this.moodfelek.image = res.data.image;
            this.$vs.notify({
              color: "success",
              title: "Başarılı !",
              text: "Moodfelek Güncellendi."
            });
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Kampanyalar Yüklenemedi !"
            });
          }
        }).catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !"
          });
        });
      },
      updateCurrImg(input) {
        this.needUpload = true;
        if (input.target.files && input.target.files[0]) {
          var reader = new FileReader()
          reader.onload = e => {
            this.moodfelek.image = e.target.result
          }
          reader.readAsDataURL(input.target.files[0])
          this.moodfelekPhotoBinary = input.target.files[0];
        }
      },
      updateCurrImgEng(input) {
        this.needUploadEng = true;
        if (input.target.files && input.target.files[0]) {
          var reader = new FileReader()
          reader.onload = e => {
            this.moodfelek.imageEng = e.target.result
          }
          reader.readAsDataURL(input.target.files[0])
          this.moodfelekPhotoBinaryEng = input.target.files[0];
        }
      },
      moveToLeft(selective) {
        let defaultDataSet = this.campaigns;
        let dataSet = this.moodfelek.campaigns;
        if (!selective) {
          dataSet.forEach(x => {
            x.sizes = [];
            defaultDataSet.unshift(x);
          });
          dataSet.length = 0;
        } else {
          let toDelete = [];
          dataSet.forEach((x, index) => {
            if (x.selected) {
              x.selected = false;
              defaultDataSet.push(x);
              toDelete.push(index);
            }
          });
          toDelete.forEach((x, index) => {
            dataSet.splice(x - index, 1);
          });
        }
      },
      moveToRight(selective) {
        let defaultDataSet = this.campaigns;
        let dataSet = this.moodfelek.campaigns;
        if (!selective) {
          defaultDataSet.forEach(x => {
            dataSet.unshift(x);
          });
          defaultDataSet.length = 0;
        } else {
          let toDelete = [];
          let movingIds = [];
          defaultDataSet.forEach((x, index) => {
            if (x.selected) {
              x.selected = false;
              dataSet.push(x);
              toDelete.push(index);
              movingIds.push(x.id);
            }
          });
          toDelete.forEach((x, index) => {
            defaultDataSet.splice(x - index, 1);
          });
        }
      }
    },
    mounted: function () {
      this.getMoodfelekSettings();
      this.getCampaignNameList();
    },
  }

</script>

<style>
  #moodfelekSettingsPage .campaignList {
    border-bottom: 1px solid #00000040 !important;
    width: 100%;
  }

  #moodfelekSettingsPage .selectedCampaign {
    background-color: rgba(var(--vs-primary), 1);
    color: white !important;
  }

  #moodfelekCampaignOptions .vs-list {
    max-height: 69vh;
    overflow: auto;
  }

  #moodfelekCampaignOptions .vs-list .cursor-move {
    min-height: 15vh;
    max-height: 69vh;
    padding: 0 !important;
  }

</style>
